import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { channelsQuery } from '../../../graph-ql/queries';
import { ChannelResponse } from '../../models/channel/channel.response';

@Injectable()
export class ChannelService {

  constructor(public apollo: Apollo) {
  }

  channelQuery$(page: number, itemPerPage: number, flag: boolean): Observable<ChannelResponse> {
    return this.apollo.query<ChannelResponse>({
      query: channelsQuery,
      variables: {
        channelInput: {
          paginationInput: {
            page,
            itemPerPage
          },
          dropdownWithRulesInput: {
            channel: '',
            dropdownWithRulesFlag: flag
          }
        }
      }
    })
    .pipe(map(result => {
      if (!result.data['getChannels']) {
        return new ChannelResponse([], 0);
      }

      return new ChannelResponse(result.data['getChannels']['channels'],
      result.data['getChannels']['totalCount']
    );
    }
      ));
  }
}
